<template>
  <div class="gallery-subs">
    <TextArea/>
    <Subscribe/>
  </div>
</template>
<script>
import Subscribe from '../Gallery/Subscribe.vue'
import TextArea from '../Gallery/TextArea.vue'
export default {
  data () {
    return {

    }
  },
  components: {
    Subscribe,
    TextArea
  }
}
</script>
